import { render, staticRenderFns } from "./UnsupportedResolutions.vue?vue&type=template&id=1acba3c6&scoped=true&"
import script from "./UnsupportedResolutions.vue?vue&type=script&lang=js&"
export * from "./UnsupportedResolutions.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedResolutions.vue?vue&type=style&index=0&id=1acba3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acba3c6",
  null
  
)

export default component.exports